var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.385-612q35.477 0 63.046 27.569Q912-556.862 912-521.385v55.668q0 6.159-1.231 13.553-1.23 7.395-5.23 13.856L788.272-159.293q-10.195 20.37-30.949 33.832Q736.569-112 714.179-112H280.923v-500l211.385-214.385q18.846-18.846 41.231-24.962 22.384-6.115 41.154 3.27 18.769 9.384 25.653 32.192 6.885 22.808.193 49.116L565.385-612h256Zm-474.462 27.077V-178h355.539q8.461 0 17.307-4.615 8.846-4.616 13.462-15.385L846-466v-55.385q0-10.769-6.923-17.692T821.385-546H479.692L533-771.462 346.923-584.923ZM176.615-112q-38.654 0-64.634-25.981Q86-163.961 86-202.615v-318.77q0-38.654 25.981-64.634Q137.961-612 176.615-612h104.308v66H176.615q-10.769 0-17.692 6.923T152-521.385v318.77q0 10.769 6.923 17.692T176.615-178h104.308v66H176.615Zm170.308-66v-406.923V-178Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumbUp.814226963fde83c7b64eeb822ac5c0e3.svg";
export { ForwardRef as ReactComponent };